import { Route, Routes } from "react-router-dom";
import { NavItems } from "../../../common/helpers/navigation";
import { SignupLandingShell } from "../components/SignupLandingShell";
import { ContactConfirm } from "./contactConfirm";
import { ContactSales } from "./contactSales";

export const ContactLanding = (): JSX.Element => {
    return (
        <SignupLandingShell>
            <Routes>
                <Route path="*" element={<ContactSales />} />
                <Route path={NavItems.Signup.ContactSales.relativePath} element={<ContactSales />} />
                <Route path={NavItems.Signup.ContactConfirm.relativePath} element={<ContactConfirm />} />
            </Routes>
        </SignupLandingShell>
    );
};
